interface EditPredictionsSVGProps {
  fillColor: string;
}

export const EditPredictionsSVG = ({ fillColor }: EditPredictionsSVGProps) => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 25V22.9292L20.3 16.6292L22.3708 18.7L16.0708 25H14ZM3.5 18.875V17.125H12.25V18.875H3.5ZM23.625 17.4458L21.5542 15.375L22.4 14.5292C22.5556 14.3736 22.7597 14.2958 23.0125 14.2958C23.2653 14.2958 23.4694 14.3736 23.625 14.5292L24.4708 15.375C24.6264 15.5306 24.7042 15.7347 24.7042 15.9875C24.7042 16.2403 24.6264 16.4444 24.4708 16.6L23.625 17.4458ZM3.5 14.0625V12.3125H17.2083V14.0625H3.5ZM3.5 9.25V7.5H17.2083V9.25H3.5Z"
        fill={fillColor}
      />
    </svg>
  );
};
